import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "page-wrap" }
const _hoisted_2 = { class: "grid gap-4 md:grid-cols-2" }
const _hoisted_3 = ["value"]
const _hoisted_4 = { class: "mt-5 flex flex-wrap items-center gap-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UiPageHero = _resolveComponent("UiPageHero")!
  const _component_UiInput = _resolveComponent("UiInput")!
  const _component_UiSelect = _resolveComponent("UiSelect")!
  const _component_UiButton = _resolveComponent("UiButton")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(_component_UiPageHero, {
      eyebrow: "Tài khoản",
      title: "Đăng ký tài khoản mới",
      description: "Tạo tài khoản người dùng và gán quyền truy cập theo khoa/phòng."
    }),
    _createElementVNode("form", {
      class: "panel-pad max-w-4xl",
      onSubmit: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => ($setup.submit && $setup.submit(...args)), ["prevent"]))
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_UiInput, {
          modelValue: $setup.form.username,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.form.username) = $event)),
          label: "Tên đăng nhập",
          required: ""
        }, null, 8, ["modelValue"]),
        _createVNode(_component_UiInput, {
          modelValue: $setup.form.password,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.form.password) = $event)),
          label: "Mật khẩu",
          type: "password",
          required: ""
        }, null, 8, ["modelValue"]),
        _createVNode(_component_UiInput, {
          modelValue: $setup.form.fullname,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.form.fullname) = $event)),
          label: "Họ tên",
          required: ""
        }, null, 8, ["modelValue"]),
        _createVNode(_component_UiInput, {
          modelValue: $setup.form.phoneNumber,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.form.phoneNumber) = $event)),
          label: "Số điện thoại"
        }, null, 8, ["modelValue"]),
        _createVNode(_component_UiSelect, {
          modelValue: $setup.form.permission,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.form.permission) = $event)),
          label: "Quyền"
        }, {
          default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
            _createElementVNode("option", { value: "user" }, "Người dùng", -1),
            _createElementVNode("option", { value: "admin" }, "Quản trị viên", -1)
          ]))]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_UiSelect, {
          modelValue: $setup.form.idKhoaPhong,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.form.idKhoaPhong) = $event)),
          modelModifiers: { number: true },
          label: "Khoa/phòng"
        }, {
          default: _withCtx(() => [
            _cache[8] || (_cache[8] = _createElementVNode("option", { value: 0 }, "Chọn khoa/phòng", -1)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.khoaPhong, (item) => {
              return (_openBlock(), _createElementBlock("option", {
                key: item.id,
                value: item.id
              }, _toDisplayString(item.tenKhoaPhong), 9, _hoisted_3))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_UiButton, {
          type: "submit",
          icon: "userAdd",
          loading: $setup.loading,
          "loading-text": "Đang tạo..."
        }, {
          default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
            _createTextVNode(" Tạo tài khoản ", -1)
          ]))]),
          _: 1
        }, 8, ["loading"]),
        _createVNode(_component_UiButton, {
          to: "/userlist",
          variant: "secondary",
          icon: "view"
        }, {
          default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
            _createTextVNode(" Danh sách tài khoản ", -1)
          ]))]),
          _: 1
        })
      ])
    ], 32)
  ]))
}